import Home from "./Home";
import Customization from "./Customization";
const routes = [
  {
    key: "home",
    route: "/",
    component: <Home />,
  },
    {
      key: "customization",
      route: "/:type/:customizationId",
      component: <Customization />,
    },
];

export default routes;
